import { Component, input, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NotificationType } from '../../domain/model/enums/notificationType';
import { CommonModule } from '@angular/common';
import { OverlayRef } from '@angular/cdk/overlay';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [ MatIconModule, CommonModule],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.css'
})
export class NotificationComponent {
  @Input() overlayRef!: OverlayRef;
  @Input() message: string = "";
  @Input() type: NotificationType | undefined;
  @Input() title: string = "";
  closeColor:string = '';
  iconColorCss:string= '';
  ccsClass = ''
  getColor(){
    switch(this.type){
      case NotificationType.Error:
        this.iconColorCss = 'icon-color-danger';
        this.closeColor = '#5F2120';
        this.ccsClass = 'notification-container notification-body-bg-error';
      break;
      case NotificationType.Success:
        this.iconColorCss = 'icon-color-success';
        this.ccsClass = 'notification-container notification-body-bg-success';
   
      break;
      case NotificationType.Info:
        this.iconColorCss = 'icon-color-info';
        this.ccsClass = 'notification-container notification-body-bg-info';
   
      break;
      case NotificationType.InfoStepper:
        this.iconColorCss = 'icon-color-info-stepper';
        this.ccsClass = 'notification-container-stepper notification-body-bg-info';
   
      break;
    }
  }

   close(){
    this.overlayRef.detach();
   }
}
